module.exports = "varying vec2 f_uv;\r\n\r\nvoid main() {\r\n    f_uv = uv;\r\n    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/post/pass.vert.glsl
// module id = 21
// module chunks = 0